// covered-by: frontends/carrie/src/ask-v2/home/__tests__/AskV2Home.test.tsx
import cx from "classnames";
import { type ButtonHTMLAttributes, type ReactNode } from "react";

// why: Figma pill chips use radius/full + 32px icons — Radix outline Button is soft-radius and 16px
export const WELCOME_ACTION_BUTTON_CLASS =
  "inline-flex h-10 shrink-0 items-center justify-center gap-3 rounded-full border border-[color:var(--blue-a8)] bg-transparent px-4 text-base font-medium leading-6 text-[color:var(--blue-a11)] transition-colors hover:bg-puntt-blue-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-puntt-blue-9 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

export const WELCOME_ACTION_ICON_CLASS =
  "inline-flex size-8 shrink-0 items-center justify-center [&_svg]:size-8";

type WelcomeActionButtonProps = {
  chipId: string;
  icon: ReactNode;
  children: ReactNode;
  "data-testid"?: string;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children">;

/**
 * Home welcome prompt chip — fully rounded accent outline with a 32px icon,
 * matching the September 2026 Ask Puntt home Figma (node 51008:14490).
 */
export function WelcomeActionButton({
  chipId,
  icon,
  children,
  className,
  type = "button",
  "data-testid": dataTestId,
  ...rest
}: WelcomeActionButtonProps) {
  return (
    <button
      type={type}
      data-testid={dataTestId ?? `ask-v2-welcome-chip-${chipId}`}
      data-chip={chipId}
      className={cx(WELCOME_ACTION_BUTTON_CLASS, className)}
      {...rest}
    >
      <span className={WELCOME_ACTION_ICON_CLASS} aria-hidden="true">
        {icon}
      </span>
      {children}
    </button>
  );
}
